import { ScheduleApplicationsViewColumn } from "@common/types/views/scheduleApplicationsView";
import { AMOUNT_COLUMN_SIZE } from "@design-system/ViewTable/DefaultColumnSizes";
import { ViewConfig } from "@lib/views";
import {
    ScheduleApplicationAmountCell,
    ScheduleApplicationRemainingBalanceCell,
} from "./Cells/ScheduleApplicationAmountCells";
import {
    ScheduleApplicationClassCell,
    ScheduleApplicationCounterpartyCell,
    ScheduleApplicationDateCell,
    ScheduleApplicationEntityCell,
    ScheduleApplicationGroupCell,
    ScheduleApplicationSplitCell,
    ScheduleApplicationTemplateCell,
} from "./Cells/ScheduleApplicationInfoCells";
import { ScheduleApplicationActionsCell } from "./Cells/ScheduleApplicationActionsCell";
import { ScheduleApplicationMatchCell } from "./Cells/ScheduleApplicationMatchCell";
import { ScheduleApplicationStatusCell } from "./Cells/ScheduleApplicationStatusCell";
import { ScheduleApplicationTypeCell } from "./Cells/ScheduleApplicationTypeCell";
import {
    ScheduleApplicationDescriptionCell,
    ScheduleApplicationLineItemCell,
    ScheduleApplicationReferenceCell,
} from "./Cells/ScheduleApplicationLinkCells";
import { ScheduleApplicationRow } from "./scheduleApplicationRowHelpers";

export const scheduleApplicationsViewConfig: ViewConfig<
    ScheduleApplicationRow,
    ScheduleApplicationsViewColumn,
    never
> = {
    columns: {
        [ScheduleApplicationsViewColumn.DATE]: {
            accessorKey: "date",
            name: "Date",
            header: "Date",
            cell: ScheduleApplicationDateCell,
            immutable: true,
            minSize: 150,
            maxSize: 170,
        },
        [ScheduleApplicationsViewColumn.TEMPLATE]: {
            accessorKey: "templateName",
            name: "Policy",
            header: "Policy",
            cell: ScheduleApplicationTemplateCell,
            minSize: 160,
            maxSize: 280,
        },
        [ScheduleApplicationsViewColumn.GROUP]: {
            accessorKey: "group",
            name: "Group",
            header: "Group",
            cell: ScheduleApplicationGroupCell,
            minSize: 120,
            maxSize: 200,
        },
        [ScheduleApplicationsViewColumn.TYPE]: {
            accessorKey: "sourceType",
            name: "Source",
            header: "Source",
            cell: ScheduleApplicationTypeCell,
            minSize: 90,
            maxSize: 130,
        },
        [ScheduleApplicationsViewColumn.REFERENCE]: {
            accessorKey: "id",
            name: "Reference",
            header: "Reference",
            cell: ScheduleApplicationReferenceCell,
            minSize: 120,
            maxSize: 180,
        },
        [ScheduleApplicationsViewColumn.DESCRIPTION]: {
            accessorKey: "description",
            name: "Description",
            header: "Description",
            cell: ScheduleApplicationDescriptionCell,
            minSize: 200,
            maxSize: 480,
        },
        [ScheduleApplicationsViewColumn.LINE_ITEM]: {
            accessorKey: "lineItemLabel",
            name: "Line item",
            header: "Line item",
            cell: ScheduleApplicationLineItemCell,
            minSize: 160,
            maxSize: 320,
        },
        [ScheduleApplicationsViewColumn.COUNTERPARTY]: {
            accessorKey: "counterpartyName",
            name: "Counterparty",
            header: "Counterparty",
            cell: ScheduleApplicationCounterpartyCell,
            minSize: 140,
            maxSize: 240,
        },
        [ScheduleApplicationsViewColumn.CLASS]: {
            accessorKey: "entityId",
            name: "Class",
            header: "Class",
            cell: ScheduleApplicationClassCell,
            minSize: 70,
            maxSize: 110,
        },
        [ScheduleApplicationsViewColumn.SPLIT]: {
            accessorKey: "splitLabel",
            name: "Split",
            header: "Split",
            cell: ScheduleApplicationSplitCell,
            minSize: 180,
            maxSize: 300,
        },
        [ScheduleApplicationsViewColumn.AMOUNT]: {
            accessorKey: "amount",
            name: "Amount",
            header: "Amount",
            cell: ScheduleApplicationAmountCell,
            ...AMOUNT_COLUMN_SIZE,
        },
        [ScheduleApplicationsViewColumn.REMAINING_BALANCE]: {
            accessorKey: "remainingAmount",
            name: "Remaining balance",
            header: "Remaining balance",
            cell: ScheduleApplicationRemainingBalanceCell,
            minSize: 140,
            maxSize: 200,
        },
        [ScheduleApplicationsViewColumn.MATCH]: {
            accessorKey: "id",
            name: "Match",
            header: "Match",
            cell: ScheduleApplicationMatchCell,
            immutable: true,
            minSize: 160,
            maxSize: 260,
        },
        [ScheduleApplicationsViewColumn.ENTITY]: {
            accessorKey: "entityId",
            name: "Entity",
            header: "Entity",
            cell: ScheduleApplicationEntityCell,
            minSize: 70,
            maxSize: 110,
        },
        [ScheduleApplicationsViewColumn.STATUS]: {
            accessorKey: "status",
            name: "Status",
            header: "Status",
            cell: ScheduleApplicationStatusCell,
            immutable: true,
            minSize: 120,
            maxSize: 160,
        },
        [ScheduleApplicationsViewColumn.ACTIONS]: {
            accessorKey: "id",
            name: "Actions",
            header: "",
            cell: ScheduleApplicationActionsCell,
            immutable: true,
            hiddenFromSettings: true,
            minSize: 56,
            maxSize: 56,
        },
    },
    nesting: {
        enabled: true,
        expandColumn: ScheduleApplicationsViewColumn.DATE,
        childrenKey: "children",
    },
};
